export default {
	SERVER_1: process.env.STUN_SERVER_1 ?? "",
	SERVER_2: process.env.STUN_SERVER_2 ?? "",
};
